import { render } from "./QualityPlanPage.vue?vue&type=template&id=2b322528&scoped=true"
import script from "./QualityPlanPage.vue?vue&type=script&lang=js"
export * from "./QualityPlanPage.vue?vue&type=script&lang=js"

import "./QualityPlanPage.vue?vue&type=style&index=0&id=2b322528&lang=css"
import "./QualityPlanPage.vue?vue&type=style&index=1&id=2b322528&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b322528"]])

export default __exports__